export default __webpack_public_path__ + "static/media/navbar-company-orange.2875f5f8.svg";